export default {
  title: 'Vă mulțumim că ați trimis informațiile pentru a primi plăți',
  description:
    'Verificarea de către Stripe poate dura până la 48 de ore. Între timp, puteți continua cu pașii următori. Vă vom informa prin email imediat ce informațiile dvs. sunt confirmate.',
};
